import { render, staticRenderFns } from "./ProgramsSingleManagerAssignments.vue?vue&type=template&id=0ca1e858&"
import script from "./ProgramsSingleManagerAssignments.vue?vue&type=script&lang=js&"
export * from "./ProgramsSingleManagerAssignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports